import { TableComment } from "../../../general/src/TableComment";
import { TableContact } from "../../../general/src/TableContact";
import { CallRecordTable } from "../CallRecordTable";
import { DetentionHistoryTable } from "../DetentionHistoryTable";
import { ProductBookTable } from "../ProductBookTable";
import { ProhibitedTable } from "../ProhibitedTable";
import { TrailerPool } from "../TrailerPool";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, Map, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLocation extends Layout {
    buttonAllCalls: Button;
    buttonConvertToProspect: Button;
    buttonLocationUsers: Button;
    buttonOpenClassic: Button;
    checkApptRequired: Checkbox;
    checkConsignee: Checkbox;
    checkCustomer: Checkbox;
    checkDistCenter: Checkbox;
    checkShipper: Checkbox;
    checkboxIsDropYard: Checkbox;
    checkboxIsGeocoded: Checkbox;
    checkboxIsProspect: Checkbox;
    dataheader1: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    imageGooglePlaces: Image;
    labbelThursdayHours: Label;
    labelCbpTitle: Label;
    labelCbsaTitle: Label;
    labelFridayHours: Label;
    labelHeaderContactEmail: Label;
    labelHeaderContactName: Textbox;
    labelHeaderContactPhone: Label;
    labelHeaderLocAddr: Label;
    labelHeaderLocCSZ: CityState;
    labelHeaderLocName: Textbox;
    labelLocationHours: Label;
    labelMondayHours: Label;
    labelSaturdayHours: Label;
    labelSundayHours: Label;
    labelTuesdayHours: Label;
    laebelWednesdayHours: Label;
    layout1: ProhibitedTable;
    layoutCallRecord: CallRecordTable;
    layoutContactTable: TableContact;
    layoutDetentionHistoryTable: DetentionHistoryTable;
    layoutProductBookTable: ProductBookTable;
    layoutTableComment: TableComment;
    layoutTrailerPool: TrailerPool;
    mapLocation: Map;
    panel1: Panel;
    panel2: Panel;
    panel3: Panel;
    panel4: Panel;
    panel5: Panel;
    panel6: Panel;
    panelCustoms: Panel;
    panelDetailCenter: Panel;
    panelHeader: Panel;
    panelHeaderContact: Panel;
    panelHeaderLocation: Panel;
    sourceAgencyLink: DataSource;
    sourceCallRecord: DataSource;
    sourceComments: DataSource;
    sourceContacts: DataSource;
    sourceDetentionHistoryLookup: DataSource;
    sourceLocation: DataSource;
    sourceLocationCommodity: DataSource;
    sourceProhibited: DataSource;
    switchCustomsBroker: Switch;
    switchIsActive: Switch;
    switchLoadUnloadExclude: Switch;
    tabComments: Tab;
    tabContacts: Tab;
    tabCustoms: Tab;
    tabDetail: Tab;
    tabDetention: Tab;
    tabGeneral: Tab;
    tabIntegration: Tab;
    tabMap: Tab;
    tabProductBook: Tab;
    tabProhibited: Tab;
    tabSalesCalls: Tab;
    tabTrailerPool: Tab;
    tabsetLocation: Tabset;
    textDirections: Textbox;
    textFridayClose: Textbox;
    textFridayOpen: Textbox;
    textId: Textbox;
    textLoadingInstructions: Textbox;
    textMondayClose: Textbox;
    textMondayOpen: Textbox;
    textReceivingInstructions: Textbox;
    textSaturdayClose: Textbox;
    textSaturdayOpen: Textbox;
    textSundayClose: Textbox;
    textSundayOpen: Textbox;
    textThursdayClose: Textbox;
    textThursdayOpen: Textbox;
    textTuesdayClose: Textbox;
    textTuesdayOpen: Textbox;
    textWednesdayClose: Textbox;
    textboxAddress1: Textbox;
    textboxAddress2: Textbox;
    textboxAssignedTo: Textbox;
    textboxCategory: Textbox;
    textboxCbpPort: Textbox;
    textboxCbsaPort: Textbox;
    textboxCity: CityState;
    textboxCommodityId: Textbox;
    textboxCustomerId: Textbox;
    textboxDaysBetweenCalls: Textbox;
    textboxDeliveryOptions: Textbox;
    textboxDriverLoadId: Textbox;
    textboxDriverUnloadId: Textbox;
    textboxFilerCode: Textbox;
    textboxGooglePlaceId: Textbox;
    textboxGeofenceRadius: Textbox;
    textboxGooglePlacesSearch: Textbox;
    textboxLastUsedDate: Textbox;
    textboxLatitude: Textbox;
    textboxLoadUnloadCount: Textbox;
    textboxLoadUnloadParam: Textbox;
    textboxLoadingTime: Textbox;
    textboxLongitude: Textbox;
    textboxName: Textbox;
    textboxNextCallDate: Textbox;
    textboxPNNCity: CityState;
    textboxPickupOptions: Textbox;
    textboxUnloadingTime: Textbox;
    textboxWebsiteUrl: Textbox;
    textdnesdayOpen: Textbox;
}
